import { useFeatureFlags, type FeatureFlag } from 'hooks/useFeatureFlags'
import { FC, ReactNode } from 'react'
import { Navigate } from 'react-router-dom'

type FlaggedRouteProps = {
  flag: FeatureFlag
  children: ReactNode
}

export const FlaggedRoute: FC<FlaggedRouteProps> = ({ flag, children }) => {
  const flags = useFeatureFlags()

  return flags[flag] ? children : <Navigate to="/home" />
}
